<template>
	<svg id="right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<path d="M71.05,51.89,98.33,79.17H33.72a8.33,8.33,0,0,0-8.33,8.33v25a8.33,8.33,0,0,0,8.33,8.33H98.33L71.05,148.11a8.32,8.32,0,0,0,0,11.78l17.67,17.67a8.34,8.34,0,0,0,11.78,0l71.67-71.67a8.34,8.34,0,0,0,0-11.78L100.5,22.44a8.34,8.34,0,0,0-11.78,0L71.05,40.11A8.32,8.32,0,0,0,71.05,51.89Z"/>
	</svg>
</template>

<script>
export default {
	name: "ArrowRight"
}
</script>
